<template>
  <div>
    <v-select class="mx-4" :items="periodos" label="Periodo"></v-select>
    <v-btn :color="$pgsHelper.uiConfig().mainColor" dark class="my-2 mx-2">
      Agregar movimiento
    </v-btn>
    <v-btn color="green" dark
      ><v-icon>mdi-file-excel-box</v-icon>
      <download-excel type="xls" name="Reporte General" :data="[{}]">
        Exportar a Excel
      </download-excel>
    </v-btn>
    <v-card elevation="0">
      <v-card-text>
        <v-card elevation="0">
          <v-list-item elevation="0">
            <v-list-item-avatar>
              <v-icon class="red lighten-1" dark> mdi-arrow-down-circle </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> Cargo por membresia </v-list-item-title>
              <v-list-item-subtitle>10-05-2022</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <div class="text-h5">$1000</div>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item elevation="0">
            <v-list-item-avatar>
              <v-icon class="green lighten-1" dark> mdi-arrow-up-circle </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title> Su Pago </v-list-item-title>
              <v-list-item-subtitle>10-05-2022</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <div class="text-h5">$5000</div>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "MovimientosLineasCredito",
  components: {},
  props: ['idLinea'],
  data() {
    return {
      clicked: false,
      periodos: [
        { value: "Actual", text: "Periodo Actual" },
        { value: "Anterior", text: "Periodo Anterior" },
      ],
    };
  },
  methods: {},
  computed: {},
  watch: {},
  mounted() {},
  created() {},
};
</script>